import { render, staticRenderFns } from "./classRoomClosed.vue?vue&type=template&id=06baa99c&scoped=true"
import script from "./classRoomClosed.vue?vue&type=script&lang=js"
export * from "./classRoomClosed.vue?vue&type=script&lang=js"
import style0 from "./classRoomClosed.vue?vue&type=style&index=0&id=06baa99c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06baa99c",
  null
  
)

export default component.exports